module.exports = __webpack_public_path__ + "assets/img/siding-2.b04ff3cd.jpg";